/* eslint-disable max-lines */
/* eslint-disable vars-on-top */
/* eslint-disable no-underscore-dangle */
/* eslint-disable id-length */
ACC.availabilityinfo = {
  todaysUnitLbl: $('#ph-todayunits__text').val(),
  futureUnitLbl: $('#ph-futureunits__text').val(),
  todaysLbl: $('#ph-todaylbl__text').val(),
  bgColor: 'rgba(25,72,116,1)',
  bindall: function() {
    this.loadAvailability();
    this.handleToggle();
  },
  handleToggle: function() {
    var avar = '.ph-avail-arrow';

    $(avar).click(function() {
      $(avar).toggleClass('ph-avail-arrow-down');
      $('#canvas').toggle();
    });
  },
  addOriginToGraph: function(horizontalBarChartData) {
    if (!horizontalBarChartData.datasets[0].data.includes('0')) {
      horizontalBarChartData.labels.push(' ');
      horizontalBarChartData.datasets[0].data.push('0');
    }
  },
  checkForTodaysDate: function(localeStr) {
    var today = new Date(),
        date = today.getDate(),
        month = today.getMonth() + 1,
        year = today.getFullYear(),
        currentDate = '';

    if (date.toString().length < 2) {
      date = '0' + date;
    }

    if (month.toString().length < 2) {
      month = '0' + month;
    }

    currentDate = date + '/' + month + '/' + year;

    if (localeStr.includes('.')) {
      currentDate = date + '.' + month + '.' + year;
    } else if (localeStr.includes('-')) {
      currentDate = date + '-' + month + '-' + year;
    }

    return currentDate;
  },
  customizeGraphLabels: function(horizontalBarChartData, availabilityCode) {
    for (var index = 0; index < horizontalBarChartData.labels.length; index = index + 1) {
      if (index === 0 && availabilityCode !== 'red') {
        horizontalBarChartData.labels[index] = ACC.availabilityinfo.todaysLbl;
        horizontalBarChartData.datasets[0].backgroundColor[index] = '#f2c544';
      }
    }
  },
  showErrorMsg: function(errmsg) {
    $(errmsg).css('display', 'block');
  },
  loadAvailability: function() {
    var horizontalBarChartData = {
          labels: [],
          datasets: [
            {
              backgroundColor: [
                ACC.availabilityinfo.bgColor,
                ACC.availabilityinfo.bgColor,
                ACC.availabilityinfo.bgColor,
                ACC.availabilityinfo.bgColor,
                ACC.availabilityinfo.bgColor,
                ACC.availabilityinfo.bgColor
              ],
              label: '',
              data: []
            }
          ]

        },
        ctx = 7,
        count = 0,
        chdat = 0,
        maxStock = 0,
        availabilityCode = '',
        avarw = '.ph-avail-arrow',
        cvs = 'ph-chartjs-monitor',
        errorMsg = '.ph-avail-error',
        pcode = $('#ph-prod-code').val();

    $.ajax({
      url: ACC.config.encodedContextPath + '/asyncproduct/getatpdata',
      type: 'POST',
      datatype: 'json',
      data: {
        code: pcode
      },
      success: function(data) {
        if (data.atpData.atpTrafficLightMap) {
          if ($.isEmptyObject(data.atpData.atpTrafficLightMap)) {
            $(cvs).hide();
            ACC.availabilityinfo.showErrorMsg(errorMsg);
            $(avarw).hide();
          } else {
            $.each(data.atpData.atpTrafficLightMap, function(key, value) {
              if (count < 6) {
                horizontalBarChartData.labels.push(key);
                horizontalBarChartData.datasets[0].data.push(value);
                count = count + 1;
              }
            });

            maxStock = data.atpData.maxAtpGraphValue;
            availabilityCode = data.atpData.availabilityCode;
            chdat = ACC.availabilityinfo.checkcountunits(maxStock);

            for (; ctx > count; ctx = ctx - 1) {
              horizontalBarChartData.labels.push(' ');
              horizontalBarChartData.datasets[0].data.push('0');
            }

            ACC.availabilityinfo.addOriginToGraph(horizontalBarChartData);
            ACC.availabilityinfo.decidegraph(chdat, horizontalBarChartData, availabilityCode);
          }
        } else {
          $(cvs).hide();
          ACC.availabilityinfo.showErrorMsg(errorMsg);
          $(avarw).hide();
        }

        ACC.common.checkForBlockedProducts(data.code);
      },
      error: function() {
        $(cvs).hide();
        ACC.availabilityinfo.showErrorMsg(errorMsg);
        $(avarw).hide();
      }
    });
  },
  checkcountunits: function(checkVal) {
    if (checkVal < 10) {
      return '1';
    }

    return '2';
  },
  afterUpdateDesk: function(chart, offset) {
    var datasets = chart.config.data.datasets;

    for (var iDs = 0; iDs < datasets.length; iDs = iDs + 1) {
      var dataset = datasets[iDs];

      for (var counter = 0; counter < dataset._meta[0].data.length; counter = counter + 1) {
        var model = dataset._meta[0].data[counter]._model;

        if (iDs === 1) {
          model.x = model.x - (offset - 35);
        } else {
          model.x = model.x + offset;
        }
      }
    }
  },
  afterUpdateMob: function(chart, offsetMob) {
    var datasets = chart.config.data.datasets;

    for (var iDs = 0; iDs < datasets.length; iDs = iDs + 1) {
      var dataset = datasets[iDs];

      for (var icount = 0; icount < dataset._meta[0].data.length; icount = icount + 1) {
        var model = dataset._meta[0].data[icount]._model;

        if (iDs === 1) {
          model.x = model.x - (offsetMob - 10);
        } else {
          model.x = model.x + offsetMob;
        }
      }
    }
  },
  decidegraph: function(checkdat, horizontalBarChartData, availabilityCode) {
    ACC.availabilityinfo.customizeGraphLabels(horizontalBarChartData, availabilityCode);

    if (checkdat === '1') {
      ACC.availabilityinfo.bindlessAvailability(horizontalBarChartData);
    } else {
      ACC.availabilityinfo.bindAvailability(horizontalBarChartData);
    }
  },
  bindAvailability: function(dta) {
    var ctx = document.getElementById('canvas').getContext('2d');

    window.Chart.Tooltip.positioners.cursor = function(chartElements, coordinates) {
      $('.celm').val(chartElements);

      return coordinates;
    };

    window.myHorizontalBar = new window.Chart(ctx, {
      type: 'horizontalBar',
      data: dta,
      options: {
        legend: {
          display: false
        },
        scales: {
          yAxes: [
            {
              gridLines: {
                display: false
              },
              barPercentage: 0.5

            }
          ]
        },
        elements: {
          rectangle: {
            borderWidth: 0
          }
        },
        responsive: true,
        title: {
          display: true,
          text: ''
        },
        tooltips: {
          mode: 'index',
          position: 'cursor',
          intersect: true,
          yAlign: 'bottom',
          xAligh: 'bottom',
          backgroundColor: '#ffffff',
          titleFontColor: '#ffffff',
          bodyFontColor: '#666666',
          borderColor: '#cccccc',
          borderWidth: 1,
          displayColors: false,
          callbacks: {
            label: function(tooltipItems) {
              var tooltipTxt = '';

              if (tooltipItems.yLabel === ACC.availabilityinfo.todaysLbl) {
                tooltipTxt = tooltipItems.xLabel + ' ' + ACC.availabilityinfo.todaysUnitLbl;
              } else {
                tooltipTxt = tooltipItems.xLabel + ' ' + ACC.availabilityinfo.futureUnitLbl;
              }

              return tooltipTxt;
            }
          }
        }
      }
    });
  },
  bindlessAvailability: function(lessdta) {
    var lessctx = document.getElementById('canvas').getContext('2d');

    window.Chart.Tooltip.positioners.cursor = function(lesschartElements, lesscoordinates) {
      $('.celm').val(lesschartElements);

      return lesscoordinates;
    };

    window.myHorizontalBarless = new window.Chart(lessctx, {
      type: 'horizontalBar',
      data: lessdta,
      options: {
        legend: {
          display: false
        },
        scales: {
          xAxes: [
            {
              ticks: {
                max: 10,
                min: 0,
                stepSize: 2
              }
            }
          ],
          yAxes: [
            {
              gridLines: {
                display: false
              },
              barPercentage: 0.5

            }
          ]
        },
        elements: {
          rectangle: {
            borderWidth: 0
          }
        },
        responsive: true,
        title: {
          display: true,
          text: ''
        },
        tooltips: {
          mode: 'index',
          position: 'cursor',
          intersect: true,
          yAlign: 'bottom',
          xAligh: 'bottom',
          backgroundColor: '#ffffff',
          titleFontColor: '#ffffff',
          bodyFontColor: '#666666',
          borderColor: '#cccccc',
          borderWidth: 1,
          displayColors: false,
          callbacks: {
            label: function(tooltipItemsLess) {
              var tooltipTxtLess = '';

              if (tooltipItemsLess.yLabel === ACC.availabilityinfo.todaysLbl) {
                tooltipTxtLess = tooltipItemsLess.xLabel + ' ' + ACC.availabilityinfo.todaysUnitLbl;
              } else {
                tooltipTxtLess = tooltipItemsLess.xLabel + ' ' + ACC.availabilityinfo.futureUnitLbl;
              }

              return tooltipTxtLess;
            }
          }
        }
      }
    });
  }
};

$(document).ready(function() {
  if ($('#canvas').length > 0) {
    ACC.availabilityinfo.bindall();
  }
});
/* eslint-enable vars-on-top */
/* eslint-enable no-underscore-dangle */
/* eslint-enable id-length */
/* eslint-enable max-lines */
